module.exports = __webpack_public_path__ + "img/edc-sinarmas.2f3f7ab0.png";